import React, { useState } from 'react';
import FilterItem from '../FilterItem/FilterItem';
import DropdownMenu from '../DropdownMenu/DropdownMenu';
import './JuridictionFilter.css';

const JuridictionFilter = ({
    isActive,
    selectedItems,
    onToggle,
    onSelect,
    onClear,
    juridictionCategories
}) => {
    const [searchTerm, setSearchTerm] = useState('');

    const getFilteredJuridictions = () => {
        const result = {};

        Object.entries(juridictionCategories).forEach(([category, items]) => {
            const filteredItems = items.filter(item =>
                item.toLowerCase().includes(searchTerm.toLowerCase())
            );

            if (filteredItems.length > 0) {
                result[category] = filteredItems;
            }
        });

        return result;
    };

    const handleApply = () => {
        onToggle(null);
        setSearchTerm('');
    };

    return (
        <FilterItem
            label="Juridiction"
            isActive={isActive}
            hasFilters={selectedItems.length > 0}
            count={selectedItems.length}
            onToggle={() => onToggle('juridiction')}
        >
            <DropdownMenu
                title="Juridiction"
                hasSelectedItems={selectedItems.length > 0}
                onClear={() => onClear('juridiction')}
                onApply={handleApply}
            >
                <div className="search-box">
                    <span className="search-icon">🔍</span>
                    <input
                        type="text"
                        className="search-input"
                        placeholder="Rechercher une juridiction..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                </div>

                {Object.entries(getFilteredJuridictions()).map(([category, items]) => (
                    <div key={category} className="filter-group">
                        <div className="filter-group-header">{category}</div>
                        <div className="filter-options">
                            {items.map(item => (
                                <label key={item} className="filter-option">
                                    <input
                                        type="checkbox"
                                        checked={selectedItems.includes(item)}
                                        onChange={() => onSelect('juridiction', item)}
                                    />
                                    <span className="option-label">{item}</span>
                                </label>
                            ))}
                        </div>
                    </div>
                ))}

                {Object.keys(getFilteredJuridictions()).length === 0 && (
                    <div className="no-results">Aucun résultat trouvé</div>
                )}
            </DropdownMenu>
        </FilterItem>
    );
};

export default JuridictionFilter;